import Component from '../../classes/Component';
import intlTelInput from '../../plugins/intl-tel-input/intlTelInputWithUtils';
import { ru } from "../../plugins/intl-tel-input/i18n";
import { $dom } from "../../helpers/dom";
import { getMeta, respondToVisibility } from "../../helpers/_utilities";
import variables from "../../variables";
import { $style } from "../../helpers/style";
import { $events } from '../../helpers/events';
import { localizedCountries, countriesPhonePlaceholders } from "../../helpers/_countries";

const { classNames, metaNames } = variables;
const rootSelector = '.' + classNames.intlTelInput;
// const parentSelector = '.js-intl-parent';
const onlyCountriesAttr = 'data-only-countries';

export default function () {
    const $Page = this;

    return new Component({
        name: 'intlTelInput',
        requiredTargets: rootSelector,
        onInit() {
            this.initCountry = getMeta(metaNames.countryIso);
            
            this.createIntlTelInput = target => {                
                let onlyCountriesValues = target.getAttribute(onlyCountriesAttr);

                if (onlyCountriesValues) {
                    onlyCountriesValues
                        .split(',')
                        .forEach(onlyCountryName => {
                            for (const countryName in localizedCountries) {
                                if (onlyCountryName !== countryName) {
                                    delete localizedCountries[countryName]
                                }
                            }
                        });
                }

                target.intlTel = intlTelInput(target, {
                    initialCountry: this.initCountry,
                    separateDialCode: true,
                    onlyCountries: Object.keys(localizedCountries),
                    nationalMode: false,
                    i18n: {
                        ...ru,
                        rc: 'Северный Кипр'
                    },
                    hiddenInput: () => ({phone: 'phone'}),
                    strictMode: true,
                    useFullscreenPopup: false,
                    validationNumberType: 'FIXED_LINE_OR_MOBILE',
                    customPlaceholder: function (selectedPlaceholder, selectedData) {
                        const existingPl = countriesPhonePlaceholders[selectedData?.iso2];
                    
                        if (existingPl)
                            return existingPl.replaceAll('*', '9')
                    
                        return selectedPlaceholder
                    },
                });
            };
            
            this.handleInput = e => {
                const formValidation = $Page.components?.formValidation;
                
                formValidation?.validatePhoneInput(e.target);
            };

            this.handleInputChange = e => {
                let target = e instanceof Event ? e.target : e;
                if (!target) return;

                const nextEl = target.nextElementSibling;
                
                if (nextEl.tagName.toLowerCase() === 'input' && nextEl.getAttribute('name') === 'phone')
                    nextEl.value = target?.intlTel.getNumber()
            };
            
            this.handleInputPaste = e => {
                e.preventDefault();
                let paste = (e.clipboardData || window.clipboardData).getData('text');
                if (!paste) return;
                const iti = e.target?.intlTel;
                if (!iti) return;

                iti.setNumber('+'+paste.replace(/\D/g,''));
            };

            $dom.each(this.targets, target => {
                this.createIntlTelInput(target);
                this.handleInputChange(target);
                respondToVisibility(target, isVisible => {
                    if (isVisible) {
                        target?.intlTel._updateInputPadding()
                    }
                })
            });            

            $events.delegate
                .on('input', rootSelector, this.handleInput)
                .on('change', rootSelector, this.handleInputChange)
                .on('paste', rootSelector, this.handleInputPaste)
            ;
        },
        onDestroy() {
            $dom.each(this.targets, target => {
                if (target.intlTel) {
                    $style.remove(target, 'padding-left');
                    target.intlTel.destroy();
                }
            });

            $events.delegate
                .off('input', rootSelector, this.handleInput)
                .off('change', rootSelector, this.handleInputChange)
                .off('paste', rootSelector, this.handleInputPaste)
            ;
        }
    })
}
